import { Component } from '@angular/core';
import {CommonModule} from "@angular/common";
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
@Injectable({
  providedIn: 'root'
})
export class LoaderComponent {

}
